<app-entity-mat-dialog-title title="Drop Enrollment"></app-entity-mat-dialog-title>

<!-- <app-success-message [message]=this.successMessage></app-error-message> -->
<app-error-message [message]=this.errorMessage></app-error-message>

<div style="min-height:80px" *ngIf="showProgressSpinner">
    <mat-progress-spinner class="matProgressSpinnerCentered"
        *ngIf="showProgressSpinner" mode="indeterminate">
    </mat-progress-spinner>
</div>

<ng-container *ngIf="droppedData?.allLessonsTakenAndPaid">
	<app-warning-message [message]="'This enrollment can\'t be dropped because the enrollment has been fulfilled.'"></app-warning-message>
</ng-container>

<ng-container *ngIf="this.enrollmentEntityData?.field_dropped_date != ''">
	<app-warning-message [message]="'This enrollment has already been dropped.'"></app-warning-message>
</ng-container>

<form (ngSubmit)="onSubmit(f)" #f="ngForm" class="form">
  <div class="container">
      <div class="row">
					<div class="col-12">
						<mat-form-field>
						<mat-label>Drop Date</mat-label>
						<input #dropDateInput matInput
						[value]="dropDateDisplayValue"
						placeholder="Drop Date"
						readonly>
						<button matSuffix mat-icon-button type="button" (click)="openDropDatePicker()">
							<mat-icon>calendar_today</mat-icon>
						</button>
						</mat-form-field>
				</div>

				<div class="col-12">
					<mat-form-field class="full-width-field">
							<mat-label>Total Price</mat-label>
							<input
								required
								readonly
								name="field_drop"
								matInput
								type="number"
								ngModel="{{droppedData?.['total_price']}}">
					</mat-form-field>
			</div>

			<div class="col-12">
				<mat-form-field *ngIf="droppedData?.['total_dropped']" class="full-width-field" style="display: none;">
						<mat-label>Total Dropped</mat-label>
						<input
							required
							readonly
							name="field_total_dropped"
							matInput
							type="number"
							ngModel="{{ droppedData?.['total_dropped'] }}">
				</mat-form-field>
			</div>

    </div>

  </div>
</form>

<!-- Refund calculation -->
<ng-container *ngIf="this.enrollmentEntityData">
	<mat-card class="p-2">
		<mat-card-title class="fs-6 mb-2 text-primary">
				Drop & Refund Calculations
		</mat-card-title>

		<!-- Compact refund visual -->
		<div class="py-1 px-2 mb-2" style="background-color: #f8f9fa; border-radius: 4px;">
			<!-- Calculator-like visual -->
			<div style="border: 1px solid #eee; border-radius: 4px; padding: 8px; background-color: white; max-width: 400px; margin: 0 auto;">
				<div style="display: flex; align-items: center; margin: 4px 0;">
					<div style="min-width: 140px; font-size: 13px; font-weight: bold;">Amount Paid:</div>
					<div style="flex-grow: 1; text-align: right; font-size: 13px;">{{ getTotalAmountPaid() | studioCurrency }}</div>
				</div>

				<div style="display: flex; align-items: center; margin: 4px 0; color: #d32f2f; font-size: 13px;">
					<div style="min-width: 140px; font-weight: bold;">- Lessons Taken:</div>
					<div style="flex-grow: 1; text-align: right;">{{ getLessonsTakenValueLive() | studioCurrency }}</div>
				</div>

				<div style="display: flex; align-items: center; margin: 4px 0; color: #d32f2f; font-size: 13px;" *ngIf="getTaxesLive() > 0">
					<div style="min-width: 140px; font-weight: bold;">- Taxes:</div>
					<div style="flex-grow: 1; text-align: right;">{{ getTaxesLive() | studioCurrency }}</div>
				</div>

				<div style="display: flex; align-items: center; margin: 6px 0 2px; border-top: 1px solid #ddd; padding-top: 4px; background-color: #e8f5e9; padding: 6px 4px; border-radius: 4px; font-size: 13px;">
					<div style="min-width: 140px; font-weight: bold;">= Refund Amount:</div>
					<div style="flex-grow: 1; text-align: right; font-weight: bold; color: #4caf50;">{{ getRefundable() | studioCurrency }}</div>
				</div>

				<!-- Optional cancellation fee, withheld from the refund. Recorded on
				     the refund payment (field_cancellation_fee) and itemised on the
				     receipt; never part of tuition/tax or external reporting. -->
				<div style="display: flex; align-items: center; margin: 8px 0 2px; font-size: 13px;">
					<div style="min-width: 140px; font-weight: bold;">- Cancellation Fee:</div>
					<div style="flex-grow: 1; text-align: right;">
						<mat-form-field class="full-width-field" style="max-width: 120px;">
							<mat-label>Fee (optional)</mat-label>
							<input matInput type="number" min="0"
								[(ngModel)]="cancellationFee" name="cancellation_fee">
						</mat-form-field>
					</div>
				</div>
				<div *ngIf="getRefundable() > 0" style="display: flex; align-items: center; margin: 2px 0; border-top: 1px solid #ddd; padding: 6px 4px; font-size: 13px;">
					<div style="min-width: 140px; font-weight: bold;">= Refund to Student:</div>
					<div style="flex-grow: 1; text-align: right; font-weight: bold; color: #4caf50;">{{ getNetRefund() | studioCurrency }}</div>
				</div>
				<!-- Fee (or the part of it) no refund covers: collected from the
				     student and recorded as a $0-tuition fee payment. -->
				<ng-container *ngIf="getFeeDue() > 0">
					<div style="display: flex; align-items: center; margin: 2px 0; border-top: 1px solid #ddd; padding: 6px 4px; font-size: 13px;">
						<div style="min-width: 140px; font-weight: bold;">= Fee Due from Student:</div>
						<div style="flex-grow: 1; text-align: right; font-weight: bold; color: #d32f2f;">{{ getFeeDue() | studioCurrency }}</div>
					</div>
					<div style="display: flex; align-items: center; margin: 2px 0; font-size: 13px;">
						<div style="min-width: 140px; font-weight: bold;">Collected As:</div>
						<div style="flex-grow: 1; text-align: right;">
							<mat-form-field class="full-width-field" style="max-width: 160px;">
								<mat-label>Payment Type</mat-label>
								<mat-select [(ngModel)]="feePaymentType" name="fee_payment_type">
									<mat-option *ngFor="let element of this._taxonomyService.payment_type" [value]="element.id">
										{{ element.name }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</div>
				</ng-container>
			</div>

			<!-- Simplified explanation. Gated on the server response: before it
			     arrives every figure reads $0.00, and asserting "no payments made"
			     about an enrollment that has payments would misinform staff. -->
			<div *ngIf="!refundableData" style="text-align: center; font-size: 12px; color: #555; margin: 4px 0;">
				Calculating refund…
			</div>
			<div *ngIf="refundableData && getTotalAmountPaid() > 0 && getRefundable() <= 0" style="text-align: center; font-size: 12px; color: #d32f2f; margin: 4px 0;">
				No refund available (lessons taken value exceeds amount paid)
			</div>
			<div *ngIf="refundableData && getTotalAmountPaid() <= 0" style="text-align: center; font-size: 12px; color: #d32f2f; margin: 4px 0;">
				No refund available (no payments made)
			</div>
		</div>

		<!-- Compact enrollment details -->
		<div style="border: 1px solid #e0e0e0; border-radius: 4px; padding: 8px; font-size: 13px;">
			<div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px;">
				<!-- Left column -->
				<div>
					<div style="background-color: #f5f5f5; padding: 6px; border-radius: 4px; margin-bottom: 8px;">
						<div style="font-weight: 500; color: #555; margin-bottom: 2px; font-size: 12px;">Payment Status</div>
						<div style="font-weight: 500; font-size: 12px;">{{ this.enrollmentEntityData?.field_payments_structure === 'paid_in_full' ? 'Paid in Full' : 'Installments' }}</div>
					</div>

					<div style="background-color: #f5f5f5; padding: 6px; border-radius: 4px;">
						<div style="font-weight: 500; color: #555; margin-bottom: 2px; font-size: 12px;">Price Info</div>
						<div style="display: flex; justify-content: space-between; margin-bottom: 2px; font-size: 12px;">
							<span>Total:</span>
							<span style="font-weight: 500;">{{ this.enrollmentEntityData?.field_enrollment_total_price | studioCurrency }}</span>
						</div>
						<div style="display: flex; justify-content: space-between; margin-bottom: 2px; font-size: 12px;">
							<span>Per Lesson:</span>
							<span style="font-weight: 500;">{{ getActualLessonPrice() | studioCurrency }}</span>
						</div>
						<div style="display: flex; justify-content: space-between; font-size: 12px;" *ngIf="parseFloat(this.enrollmentEntityData?.field_taxes) > 0">
							<span>Taxes:</span>
							<span style="font-weight: 500;">{{ this.enrollmentEntityData?.field_taxes | studioCurrency }}</span>
						</div>
					</div>
				</div>

				<!-- Right column -->
				<div>
					<div style="background-color: #f5f5f5; padding: 6px; border-radius: 4px; margin-bottom: 8px;">
						<div style="font-weight: 500; color: #555; margin-bottom: 2px; font-size: 12px;">Lesson Info</div>
						<div style="display: flex; justify-content: space-between; margin-bottom: 2px; font-size: 12px;">
							<span>Total:</span>
							<span style="font-weight: 500;">{{ this.enrollmentEntityData.field_enrollment_lesson_count }}</span>
						</div>
						<div style="display: flex; justify-content: space-between; margin-bottom: 2px; font-size: 12px;">
							<span>Taken:</span>
							<span style="font-weight: 500;">{{ +(this.enrollmentEntityData?.field_lesson_used || 0) }}</span>
						</div>
						<div style="display: flex; justify-content: space-between; font-size: 12px;">
							<span>Available:</span>
							<span style="font-weight: 500;">{{ this.enrollmentEntityData.field_enrollment_lesson_count - this.enrollmentEntityData.field_lesson_used }}</span>
						</div>
					</div>

					<div style="background-color: #f5f5f5; padding: 6px; border-radius: 4px;">
						<div style="font-weight: 500; color: #555; margin-bottom: 2px; font-size: 12px;">Payment Info</div>
						<div style="display: flex; justify-content: space-between; font-size: 12px;">
							<span>Total Paid:</span>
							<span style="font-weight: 500;">{{ getTotalAmountPaid() | studioCurrency }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</mat-card>
</ng-container>

<mat-dialog-actions align="end">
        <button [disabled]="!dropDateValue || getCancellationFee() > 0 || droppedData?.allLessonsTakenAndPaid || (this.enrollmentEntityData?.field_dropped_date != '')" type="button" (click)="onSubmit(f);" mat-raised-button
            color="accent">Drop</button>
				<button [disabled]="!dropDateValue || (getRefundable() <= 0 && getCancellationFee() <= 0) || droppedData?.allLessonsTakenAndPaid || (this.enrollmentEntityData?.field_dropped_date != '')" type="button" (click)="onSubmit(f, true);" mat-raised-button
            color="accent">{{ getRefundable() > 0 ? 'Drop & Refund' : 'Drop & Charge Fee' }}</button>
      <button mat-dialog-close type="submit" mat-raised-button
            color="accent">Cancel</button>
</mat-dialog-actions>
